import type { TaskReviewLoadedProps } from './TaskReviewLoadedProps';

type Timeline = TaskReviewLoadedProps['timeline'];

/** Props both task layouts pass through to the activity card. */
export function taskTimelineViewProps(args: {
  className: string;
  taskId: string;
  timeline: Timeline;
  userNameById: Map<string, string>;
  agentNameById: Map<string, string>;
}) {
  const { timeline } = args;
  return {
    className: args.className,
    showHeading: false as const,
    view: timeline.view,
    onViewChange: timeline.setView,
    onRefresh: timeline.refresh,
    canInspectRuns: timeline.canInspectRuns,
    error: timeline.error,
    entries: timeline.entries,
    rootTaskId: args.taskId,
    userNameById: args.userNameById,
    agentNameById: args.agentNameById,
    isLoading: timeline.isLoading,
    hasMore: timeline.hasMore,
    isFetchingMore: timeline.isFetchingMore,
    onLoadMore: timeline.loadMore,
  };
}
